<template>
  <div class="entry-wrapper">
    <div class="entry-inner container-wrapper">
      <div class="left-tree">
        <tree-list-book
          :topicCategorys = "reorder"
          >
           <span class="tree-title-style">地区分布</span>
        </tree-list-book>
      </div>
      <div class="right-main">
        <bread-crumb :totalItems="totalCount"></bread-crumb>
        <div class="book-inner-search">
          <input :readonly="readonlyShow" @focus="focusHandle" placeholder="请输入志书名" v-model="innerKeyWord" @keyup.enter="handleSearch" />
          <span class="search-btn" @click="handleSearch">志书检索</span>
          <span class="BookTitle" @click="handleSort(1)" :class="{'active' : this.sortType}">按书名</span>
          <span class="Date" @click="handleSort(0)" :class="{'active' : !this.sortType}">按出版时间</span>
        </div>
        <div v-if="itemList.resulter">
          <div class="item-list" v-if="itemList.resulter.hit">
            <div class="item" v-for="(item, index) of JSON.parse(itemList.resulter.results)" :key="index">
              <div class="left">
                <img class="book-img" :src="BaseUrl + item.Id+'.gif'" v-if="item.Id" :onerror="defaultImg" @click="handleDetail(item.Id)" />
                <img class="book-img" :src="BaseUrl + 'FZ201745248'+'.gif'" v-else @click="handleDetail(item.Id)" />
              </div>
              <div class="right">
                <div class="item-title">
                  <div class="title" v-html="`${(index+1)+(itemList.resulter.pageSize) * (itemList.resulter.curPage - 1)}.${(item.BookTitle_HL || item.BookTitle)}`" @click="handleDetail(item.Id)" :title="item.BookTitle"></div>
                  <span class="reading" @click="handleCilicRead(item.Id)">阅读</span>
                </div>
                <div class="item-message">
                  <div class="message-1" v-if="item.Editorial">编纂单位：<span :title="item.Editorial">{{item.Editorial}}</span></div>
                  <div class="message-2" v-if="item.Publisher">出版单位：<span :title="item.Publisher">{{item.Publisher}}</span></div>
                  <div class="message-3" v-if="item.Date">出版时间：<span :title="item.Date">{{item.Date}}</span></div>
                  <div class="message-4" v-if="item.ISBN">ISBN：<span :title="item.ISBN">{{item.ISBN}}</span></div>
                </div>
                <p class="item-content" v-if="item.Content" v-html="item.Content_HL || item.Content"></p>
              </div>
            </div>
          </div>
          <div class="searchWarn" v-else>
            <i class="wf-icon icon-information"></i>
            没有命中记录，请重试或修改检索表达式
          </div>
          <Paganition
            v-if= "itemList.resulter.totalPage > 1"
            :total= itemList.resulter.hit
            :currentPage= itemList.resulter.curPage
            :pageSize= itemList.resulter.pageSize
            :totalPage= itemList.resulter.totalPage
            @size-change="handleUpdateData()"
            @handleCurrentChangeSub="handleCurrentChangeSub"
            name="pagination"
          >
          </Paganition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Paganition from '../../components/Pagination/Pagination'
import TreeListBook from '../../components/treeList/TreeListBook'
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb'
import {READ_URL, RESOURCE_TYPE_READ, LOGIN_IN_URL, IMG_BASE_URL} from '../../assets/constant'
export default {
  name: 'Book',
  data () {
    return {
      opt: {
        fq: [],
        pageNo: 1,
        pageSize: 10,
        query: '',
        searchType: '',
        sorts: [],
        scrollTop: 0
      },
      query: {
        CategoryA: '',
        CategoryB: '',
        totalIndex: '',
        Province: '',
        query: '',
        pageNo: 1
      },
      defaultImg:
        'this.src="http://static.wanfangdata.com.cn/LocalChronicleImages/FZ201745248.gif"',
      innerKeyWord: '',
      sortType: 0, // 1booktitle 2date
      readonlyShow:true
    }
  },
  computed: {
    ...mapState(['areaCategorysBook', 'itemList', 'userinfo']),
    BaseUrl () {
      return IMG_BASE_URL
    },
    totalCount () {
      if (this.itemList && this.itemList.resulter) {
        return this.itemList.resulter.hit
      }
    },
    reorder: function () {
      let tempArr = this.areaCategorysBook.sort(function(x, y){
        return x['value'].localeCompare(y['value'])
      })
      if (this.areaCategorysBook) {
        var newArr = tempArr.reduce((total, current) => {
          current.value !== "其他" && total.push(current)
            return total;
          }, [])
      }
      newArr.push({'value': '其他'})
      return newArr
    }
  },
  components: {
    Paganition,
    TreeListBook,
    BreadCrumb
  },
  mounted() {
    if (this.$loginAuthentication.intercept(0)) {
      this._reqRouterQuery()
      this.$store.dispatch('getAreaCategoryBook', { core: 'LocalChronicleEdu', facetPivot: ['Province'], query: this.opt.query })
      this.$store.dispatch('getItemList', this.opt)
      this._initKeyWord()
      // this.$nextTick(function () {
      //   window.addEventListener('scroll', this.handleScroll, true);
      // });
    }
  },
  destroyed () {
    // window.addEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    _initKeyWord () {
      if (this.$route.query.query) {
        this.innerKeyWord = this.$route.query.query.split(':')[1] || ''
      }
    },
    // 跳转志书详情页
    async handleDetail(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({
          path: '/detail',
          query: { BookID: id }
        })
      }
    },
    // 整书在线阅读
    async handleCilicRead(id) {
      if (await this.$loginAuthentication.intercept(0)) {
        // 整书 2
        this.$store.dispatch('savSourceType', 2)
        if (this.userinfo.users.length) {
          this.$store.dispatch('saveCurrentBookId', 0)
          this.$loginAuthentication.isAppleWechatOrQQ(READ_URL + id + RESOURCE_TYPE_READ);
        } else {
          let counter = 1
          this.$store.dispatch('saveCounter', counter)
          this.$store.dispatch('saveCurrentBookId', id)
          window.location.href = LOGIN_IN_URL + window.encodeURIComponent(window.location.href)
        }
      }
    },
    async handleSort(val) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.sortType = val
        this.opt.sorts = this.sortType ? [{ feild: 'BookTitle', order: 'desc' }] : [{ feild: 'Date', order: 'desc' }]
        this.opt.pageNo = 1
        this._replaceRouterParam(this.opt)
        this._reqRouterQuery()
        // this.$store.dispatch('getItemList', this.opt)
      }
    },
    _reqRouterQuery () {
      const Province = this.$route.query.Province || ''
      const pageNo = this.$route.query.pageNo || 1
      const query = this.$route.query.query || ''
      const sortType = this.$route.query.sortType || 0
      const fq = []
      let cat = ''
      if (Province !== '') {
        cat = `Province:${Province}`
        fq.push(cat)
      }
      this.opt.fq = fq
      this.opt.pageNo = pageNo || 1
      this.opt.query = query || ''
      this.opt.core = 'LocalChronicleEdu'
      this.opt.sorts = sortType !== 0 ? [{feild: 'BookTitle', order: 'desc'}] : [{feild: 'Date', order: 'desc'}]
      this.sortType = sortType
    },
    _replaceRouterParam (opt) {
      const Province = this.$route.query.Province
      const query = this.$route.query.query
      const pageNo = this.$route.query.pageNo
      this.$router.replace({path: 'Book',
        query: {
          Province: opt.Province || Province,
          pageNo: opt.pageNo || pageNo,
          query: opt.query || query,
          sortType: this.sortType
        }})
    },
    // 当前页改变触发
    async handleCurrentChangeSub(val) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.opt.pageNo = val
        this._replaceRouterParam(this.opt)
      }
    },
    // 检索
    handleSearch (e) {
      let input = ''
      if (this.innerKeyWord) {
        // this.$store.dispatch('clearLastItemDate')
        input = ('BookTitle:' + this.innerKeyWord.trim())
      }
      if ((this.innerKeyWord).trim() === '') {
        alert('请输入检索词')
        return
      }
      this.$router.push({path: 'book', query: {query: input, sortType: this.$route.query.sortType}})
    },
    _initTopicCategory () {
      const CategoryA = this.$route.query.CategoryA || ''
      const CategoryB = this.$route.query.CategoryB || ''
      const fq = []
      let cat = ''
      if (CategoryB !== '') {
        cat = `CategoryB:${CategoryA}#${CategoryB}`
        fq.push(cat)
      }
      if (CategoryA !== '' && CategoryB === '') {
        cat = `CategoryA:${CategoryA}`
        fq.push(cat)
      }
      // this.opt.fq = fq
      return fq
    },
    scrollToTop() {
      let timer = null;
      let _this = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_this.scrollTop > 5000) {
            _this.scrollTop -= 1000;
            window.scrollTo(0, _this.scrollTop);
            timer = requestAnimationFrame(fn);
        } else if (_this.scrollTop > 1000 && _this.scrollTop <= 5000) {
            _this.scrollTop -= 500;
            window.scrollTo(0, _this.scrollTop);
            timer = requestAnimationFrame(fn);
        } else if (_this.scrollTop > 200 && _this.scrollTop <= 1000) {
            _this.scrollTop -= 100;
            window.scrollTo(0, _this.scrollTop);
            timer = requestAnimationFrame(fn);
        } else if (_this.scrollTop > 50 && _this.scrollTop <= 200) {
            _this.scrollTop -= 10;
            window.scrollTo(0, _this.scrollTop);
            timer = requestAnimationFrame(fn);
        } else if (_this.scrollTop > 0 && _this.scrollTop <= 50) {
            _this.scrollTop -= 5;
            window.scrollTo(0, _this.scrollTop);
            timer = requestAnimationFrame(fn);
        } else {
            cancelAnimationFrame(timer);
            _this.toTopShow = false;
        }
      });
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    },
    async focusHandle(){
      this.readonlyShow = true;
      if (await this.$loginAuthentication.intercept(1)) {
        this.readonlyShow = false;
      } else {
        this.$message.warning('请先登录账号！');
      }
    }
  },
  watch: {
    // 监听主题分类参数
    '$route.query.query' () {
    },
    $route: {
      handler: function (val) {
        if (this.$loginAuthentication.intercept(0)) {
          this._initKeyWord()
          this._reqRouterQuery()
          this.$store.dispatch('getItemList', this.opt)
          this.$store.dispatch('getAreaCategoryBook', { core: 'LocalChronicleEdu', facetPivot: ['Province'], query: this.opt.query })
          if (this.$route.query.query === undefined) {
            this.innerKeyWord = ''
          }
        }
      },
      deep: true
    }
  }
}
</script>
<style lang="less" scoped>
.elipse () {
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.entry-wrapper {
  background: #e9edf0;
  min-height: 800px;
  // padding-bottom: 38px;
  &::after {
    content: "";
    position: absolute;
    background: url("../../assets/imgs/bg-lf.png") no-repeat;
    width: 204px;
    height: 226px;
    top: 680px;
  }
  &::before {
    content: "";
    position: absolute;
    background: url("../../assets/imgs/bg-rt.png") no-repeat;
    width: 204px;
    height: 226px;
    top: 920px;
    right: 0;
  }
  .entry-inner {
    position: relative;
    z-index: 1;
    overflow: hidden;
    background: #fff;
    padding-top: 20px;
  }
}
 .right-main {
  float: right;
  margin-right: 20px;
  min-height: 800px;
  margin-top: 12px;
  width:880px;
  position: relative;
  padding-bottom: 100px;
  overflow: hidden;
  .book-inner-search {
    height: 60px;
    background: #f5f8ff;
    vertical-align: middle;
    input {
      width:224px;
      height:32px;
      box-sizing: border-box;
      background:rgba(255,255,255,1);
      border:1px solid rgba(221,221,221,1);
      border-radius:4px;
      text-indent: 14px;
      padding-right: 14px;
      margin-right: 11px;
      margin-left: 14px;
    }
    &::after {
      content: '';
      height: 100%;
      display: inline-block;
      vertical-align: middle;
    }
    span {
      display: inline-block;
      border:1px solid rgba(105,124,164,1);
      border-radius:4px;
      vertical-align: middle;
      line-height: 28px;
      text-align: center;
      font-size:13px;
      font-weight:400;
      color:rgba(23,67,165,1);
      cursor: pointer;
      &.search-btn {
        width:88px;
        height:28px;
      }
      &.Date {
        width:100px;
        height:28px;
        margin-right: 10px;
        margin-left: 6px;
      }
      &.BookTitle {
        width:75px;
        height:28px;
        margin-left: 332px;
      }
      &.active {
        background: #4160a5;
        color: #FFFFFF;
      }
    }
  }
  .top-list-area {
    width:880px;
    overflow: hidden;
    background:#f5f8ff;
    margin-right: 20px;
    margin-bottom: 10px;
    .topic-list-title {
      font-weight: bold;
      color: #333333;
      line-height: 32px;
      padding-top: 15px;
      margin-left: 17px;
      margin-bottom: 5px;
      margin-right: 9px;
      overflow: hidden;
      .text-icon {
        float: left;
        font-size:14px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        line-height:32px;
      }
      .btn-export {
        float: right;
        width:76px;
        background:rgba(239,243,251,1);
        border:1px solid rgba(105,124,164,1);
        border-radius:4px;
      }
    }
  }
  .item-list {
    .item {
      width: 874px;
      padding-top: 15px;
      padding-bottom: 20px;
      border-bottom: 1px dotted #DDDDDD;
      overflow: hidden;
      .left {
        display: inline-block;
        border:1px solid rgba(221, 221, 221, 1);
        img {
          height: 133px;
          width: 94px;
          float: left;
          margin: 1px;
          cursor: pointer;
        }
      }
      .right {
        width: 755px;
        float: right;
      }
    }
    .item-title {
      background: url("../../assets/imgs/item-title-bg.png") no-repeat;
      background-position: left center;
      overflow: hidden;
      height: 30px;
      line-height: 30px;
      overflow: hidden;
      margin-bottom: 10px;
      display: block;
      padding-left: 25px;
      font-size:16px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      span {
        float: right;
        width:76px;
        height:28px;
        border-radius:14px;
        text-align: center;
        color: #4160a5;
        background-color: #F5F8FF;
        background:rgba(245,248,255,1);
        border:1px solid rgba(105,124,164,1);
        border-radius:14px;
        margin-right: 8px;
        font-size: 13px;
        cursor: pointer;
        &:hover {
          background:rgba(65,96,165,1);
          color: #FFFFFF;
        }
        &.active {
          background:rgba(65,96,165,1);
          color: #FFFFFF;
        }
      }
      p {
        display: inline-block;
        vertical-align: middle;
      }
      .title {
        max-width: 610px;
        display: inline-block;
        vertical-align: middle;
        text-align: left;
        cursor: pointer;
        .elipse();
        font-size:16px;
        font-weight:bold;
        color:rgba(51,51,51,1);
        // line-height:30px;
        &:hover {
          color: #1743a5;
          text-decoration-line: underline;
          .item-title {
            p {
              color: #1743a5;
              text-decoration-line: underline;
            }
          }
        }
        span {
          display: inline-block;
        }
      }
    }
    .item-message {
      font-size:13px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      overflow: hidden;
      width: 873px;
      margin-bottom: 10px;
      div, span {
        display: inline-block;
        vertical-align: middle;
        height: 24px;
        line-height:24px;
      }
      span {
        font-weight:400;
        height: 100%;
        margin-left: 10px;
      }
      .message-1 {
        width: 350px;
        span {
          margin-left: 10px;
        }
        span {
          width: 250px;
            .elipse();
          }
      }
      .message-2 {
        width: 350px;
        span {
          width: 250px;
            .elipse();
          }
      }
      .message-3 {
        width: 350px;
        span {
          width: 250px;
            .elipse();
          }
      }
      .message-4 {
        width: 350px;
        span {
          width: 250px;
          margin-left: 30px;
            .elipse();
          }
      }
    }
    .item-content {
      height: 36px;
      color: #666666;
      line-height: 19px;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
  .searchWarn {
    font-size: 18px;
    text-align: center;
    margin-top: 250px;
  }
}
.left-tree {
  padding: 0 20px;
  padding-bottom: 9000px;
  margin-bottom: -9000px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Book/Book.vue